import Axios from "axios";

export const SelectBCFrsLig = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/LIGBCDVFrs?type=CF&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "BCFrs_LIG_SELECT", payload: response.data });
    });
  };
};
